/**
 * Connect6 (19x19) の TypeScript 表現 (mixed-engine の serde 形と一致)。
 *
 * - 黒先 1 石、 以降 1 ターン 2 石 (= 内部は 1 ply ずつ apply)
 * - 6 連以上で勝ち。 引き分けは盤満杯のみ
 * - `pending_pair_first`: 1 ターン 2 石の 1 石目を置いた直後の座標 (null = pair 未開始)
 */

export type Side = 'First' | 'Second';

export type Connect6WinKind = 'SixInRow';
export type Connect6DrawKind = 'BoardFull';

export type Connect6Outcome =
  | { Win: { winner: Side; kind: Connect6WinKind } }
  | { Draw: { kind: Connect6DrawKind } };

export interface Connect6State {
  board: (Side | null)[][];
  side: Side;
  plies: number;
  pending_pair_first: [number, number] | null;
  outcome: Connect6Outcome | null;
}

export type Connect6Move = { Place: { row: number; col: number } };

export const CONNECT6_SIZE = 19;

export function isPlace(m: Connect6Move): m is { Place: { row: number; col: number } } {
  return typeof m === 'object' && 'Place' in m;
}

export function legalKey(row: number, col: number): string {
  return `${row}-${col}`;
}

/** outcome が Win か判定。 type-narrow ヘルパ。 */
export function isWinOutcome(
  o: Connect6Outcome | null,
): o is { Win: { winner: Side; kind: Connect6WinKind } } {
  return o != null && 'Win' in o;
}

export function isDrawOutcome(
  o: Connect6Outcome | null,
): o is { Draw: { kind: Connect6DrawKind } } {
  return o != null && 'Draw' in o;
}
